<template>
  <v-layout
    align-center
    justify-center
    row
    fill-height
    style="height:100vh; width:100vw; position: fixed; top:0; left:0; background-color: rgba(255, 255, 255, .5); z-index:1000"
  >
    <div class="loader"></div>
  </v-layout>
</template>

<script>
export default {
  name: "BaseLoader",

  data() {
    return {};
  }
};
</script>

<style scoped>
.loader {
  border: 8px solid #f3f3f3; /* Light grey */
  border-top: 8px solid #104f55; /* Blue */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
